import { render, staticRenderFns } from "./create-invoice.vue?vue&type=template&id=b3bb15e2&"
import script from "./create-invoice.vue?vue&type=script&lang=js&"
export * from "./create-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports